//需要派发的数据
import { $post } from 'utils/create-http';
export const ACTION_SET_BOOKS = 'SET_BOOKS'
export const ACTION_DELETE_BOOK='DELETE_BOOK';

export const ACTION_SET_USER_INFO='SET_USER_INFO';


export function setUserInfo(info) {
    return {
        type: ACTION_SET_USER_INFO,
        payload: info,
    };
}

export const getUserInfo=()=>{
    return dispatch=>{
        return $post('/towords_book/v1/user/get_user_info').then(res=>{
            if(res.code==200){
                dispatch(setUserInfo(res.result));
            }
        });
    }

}

export function setBooks(books) {
    return {
        type: ACTION_SET_BOOKS,
        payload: books,
    };
}

export function deleteBook(idx){
    return {
        type:ACTION_DELETE_BOOK,
        payload: idx,
    }
}

